import React from "react";
import "./PlacesGrid.css";
import sendEvent from "../../../../functions/analytics";

const PlacesGrid = ({ places, onSelect, errorAlert, selectedImages, setSelectedImages }) => {
  const handleSelectImage = placeId => {
    setSelectedImages(prev => {
      let newSelectedImages;

      if (prev.includes(placeId)) {
        sendEvent("track", "tour_params_place_deselected", { placeId });
        newSelectedImages = prev.filter(id => id !== placeId);
      } else if (prev.length < 15) {
        sendEvent("track", "tour_params_place_selected", { placeId });
        newSelectedImages = [...prev, placeId];
      } else {
        errorAlert();
        newSelectedImages = prev;
      }

      onSelect(newSelectedImages);
      return newSelectedImages;
    });
  };

  return (
    <div className="PlacesGrid">
      {places.map(place => (
        <div
          key={place.place_id}
          className={`PlacesGrid__card ${
            selectedImages.includes(place.place_id) ? "PlacesGrid__card--selected" : ""
          }`}
        >
          <div
            className={`PlacesGrid__circle ${
              selectedImages.includes(place.place_id) ? "PlacesGrid__circle--selected" : ""
            }`}
            onClick={() => handleSelectImage(place.place_id)}
          >
            {selectedImages.includes(place.place_id) && (
              <span className="PlacesGrid__check">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                  <path
                    fill="#fff"
                    stroke="#fff"
                    d="m9.55 17.3-4.975-4.95.725-.725 4.25 4.25 9.15-9.15.725.725L9.55 17.3Z"
                  />
                </svg>
              </span>
            )}
          </div>
          <div
            className="PlacesGrid__image-wrapper"
            onClick={() => handleSelectImage(place.place_id)}
          >
            <img
              height={132}
              src={place.photo_url || "https://via.placeholder.com/150"}
              alt={place.name}
              className="PlacesGrid__image"
            />
          </div>
          <div className="PlacesGrid__name">{place.name}</div>
        </div>
      ))}
    </div>
  );
};

export default PlacesGrid;
